import { memo } from 'react';
import { BehaviorSubject } from 'rxjs';
import { HoldZone } from '../functions/holdZone';
import { VoiceTurnState } from '../functions/useVoiceTurn';

/** On the web the mic shows its own hint; there is no overlay. */
export const VoiceHoldOverlay = memo(
  (_: {
    state$: BehaviorSubject<VoiceTurnState>;
    level$: BehaviorSubject<number>;
    zone$: BehaviorSubject<HoldZone>;
  }) => null,
);
